module.exports = __webpack_public_path__ + "static/media/onsoc_small@3x.323bc829.jpg";